import { PACKAGES } from '../config'

const { RECAPTCHA_KEY } = PACKAGES
const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/enterprise.js'

function validateCaptcha() {
  const captchaScript = document.head.querySelector( `script[src^="${RECAPTCHA_SCRIPT_SRC}"]` )

  if ( !captchaScript ) {
    throw new Error( 'Captcha script not loaded' )
  }

  const { grecaptcha } = window
  const grecaptchaResponse = grecaptcha.enterprise.getResponse()

  return grecaptchaResponse
}

function resetCaptcha() {
  const captchaScript = document.head.querySelector( `script[src^="${RECAPTCHA_SCRIPT_SRC}"]` )

  if ( !captchaScript ) {
    throw new Error( 'Captcha script not loaded' )
  }

  const { grecaptcha } = window
  grecaptcha.enterprise.reset()
}

export { RECAPTCHA_KEY, RECAPTCHA_SCRIPT_SRC, validateCaptcha, resetCaptcha }
